export default __webpack_public_path__ + "static/media/Feautured_2.521ff86f.png";